import { createReducer, createSetter } from "@/redux/helpers/reducer";
import { STATUS } from "@/utils/constants";

import * as actions from "./order-assign-user-via-context-menu.actions";

const initialState = {
  isFetchingUsersStatus: STATUS.IDLE,
  users: [],
  selectedUsers: [],
  unSelectedUsers: [],
};

export default createReducer(initialState, {
  [actions.setIsFetchingUsersStatus]: createSetter("isFetchingUsersStatus"),
  [actions.setUsers]: createSetter("users"),
  [actions.setSelectedUsers]: createSetter("selectedUsers"),
  [actions.setUnSelectedUsers]: createSetter("unSelectedUsers"),
  [actions.reset]: () => ({ ...initialState }),
});
